import { Component, Input, OnInit } from '@angular/core'
import { Router, NavigationStart } from '@angular/router'
import { filter } from 'rxjs/operators'
import * as _ from 'lodash'
import { select, Store } from '@ngrx/store'
import { MenuService } from 'src/app/services/ui-components/menu.service'
import * as SettingsActions from 'src/app/store/settings/actions'
import * as Reducers from 'src/app/store/reducers'
import { BasicAuthService } from '../../../../../services/basic-auth.service'
import { InstalledModule } from '../../../../../models/login-response.model'
import { MenuItem } from '../../../../../services/ui-components/menu.service.config'

@Component({
  selector: 'app-menu-left',
  templateUrl: './menu-left.component.html',
  styleUrls: ['./menu-left.component.scss'],
  standalone: false,
})
export class MenuLeftComponent implements OnInit {
  @Input() is4Mobile: boolean = false

  menuColor: String
  isMenuShadow: Boolean
  isMenuUnfixed: Boolean
  isSidebarOpen: Boolean
  isMobileView: Boolean
  leftMenuWidth: Number
  isMenuCollapsed: Boolean
  logo: String
  menuData: MenuItem[]
  menuDataActivated: MenuItem[]

  private readonly role: string
  private readonly modules: InstalledModule[] = []

  constructor(
    private menuService: MenuService,
    private basicAuthService: BasicAuthService,
    private store: Store<any>,
    private router: Router,
  ) {
    this.role = this.basicAuthService.getUserRole()
    this.modules = this.basicAuthService.getModules()
  }

  ngOnInit(): void {
    this.menuService.getMenuData().subscribe((menuData) => (this.menuData = menuData))
    this.store.pipe(select(Reducers.getSettings)).subscribe((state) => {
      this.menuColor = state.menuColor
      this.isMenuShadow = state.isMenuShadow
      this.isMenuUnfixed = state.isMenuUnfixed
      this.isSidebarOpen = state.isSidebarOpen
      this.isMobileView = state.isMobileView
      this.leftMenuWidth = state.leftMenuWidth
      this.isMenuCollapsed = state.isMenuCollapsed && !this.is4Mobile
      this.logo = state.logo
    })
    this.activateMenu(this.router.url)
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.activateMenu(event.url ? event.url : null)
      })
  }

  public hasAccess(item: any): boolean {
    return (
      this.hasAccessByRole(this.getRoles(item)) && this.hasAccessByModules(this.getModules(item))
    )
  }

  private getDistinctRoles(children: any[]): string[] {
    let roles: string[] = []
    for (let i = 0; i < children.length; i++) {
      if (children[i].roles) {
        roles = roles.concat(children[i].roles.filter((item) => roles.indexOf(item) < 0))
      }
    }
    return roles
  }

  private getDistinctModules(children: any[]): { name: string; display: boolean }[] {
    let modules: { name: string; display: boolean }[] = []
    for (let i = 0; i < children.length; i++) {
      if (children[i].modules) {
        modules = modules.concat(children[i].modules.filter((item) => modules.indexOf(item) < 0))
      } else {
        // IF at least one has no module ~ is available for all modules THEN return []
        return []
      }
    }
    return modules
  }

  private getRoles(item: any): string[] {
    let roles: string[] = []
    if (item.roles) {
      roles = item.roles
    } else if (item.children) {
      roles = this.getDistinctRoles(item.children)
    }
    return roles
  }

  private getModules(item: any): { name: string; display: boolean }[] {
    let modules: { name: string; display: boolean }[] = []
    if (item.modules) {
      modules = item.modules
    } else if (item.children) {
      modules = this.getDistinctModules(item.children)
    }
    return modules
  }

  private hasAccessByRole(roles: string[]): boolean {
    return roles.indexOf(this.role) !== -1
  }

  private hasAccessByModules(modules: { name: string; display: boolean }[]): boolean {
    if (modules.length > 0) {
      if (this.modules.length > 0) {
        for (const k in modules) {
          if (this.modules.map((m) => m['name']).indexOf(modules[k]['name']) !== -1) {
            return true
          }
        }
      }
      return false
    }
    return true
  }

  private activateMenu(url: any, menuData = this.menuData) {
    menuData = JSON.parse(JSON.stringify(menuData))
    const pathWithSelection = this.getPath({ url: url }, menuData, (entry: any) => entry, 'url')
    if (pathWithSelection) {
      pathWithSelection.pop().selected = true
      _.each(pathWithSelection, (parent: any) => (parent.open = true))
    }
    this.menuDataActivated = menuData.slice()
  }

  private getPath(
    element: any,
    source: any,
    property: any,
    keyProperty: string = 'key',
    childrenProperty: string = 'children',
    path: any[] = [],
  ) {
    let found: boolean = false
    const getElementChildren = (value: any) => _.get(value, childrenProperty)
    const getElementKey = (value: any) => _.get(value, keyProperty)
    const key = getElementKey(element)
    return (
      _.some(source, (e: any) => {
        if (getElementKey(e) === key) {
          path.push(e)
          return true
        } else {
          return (found = this.getPath(
            element,
            getElementChildren(e),
            property,
            keyProperty,
            childrenProperty,
            path.concat(e),
          ))
        }
      }) &&
      (found || _.map(path, property))
    )
  }

  // toggleSettings() {
  //   this.store.dispatch(
  //     new SettingsActions.SetStateAction({
  //       isSidebarOpen: !this.isSidebarOpen,
  //     }),
  //   )
  // }

  onCollapse(value: any): void {
    this.store.dispatch(
      new SettingsActions.SetStateAction({
        isMenuCollapsed: value,
      }),
    )
  }
}
